module.exports = __webpack_public_path__ + "img/2.7d10a908.png";